import { render } from "./MyRetirement.vue?vue&type=template&id=39ea5aec&scoped=true"
import script from "./MyRetirement.vue?vue&type=script&lang=js"
export * from "./MyRetirement.vue?vue&type=script&lang=js"

import "./MyRetirement.vue?vue&type=style&index=0&id=39ea5aec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ea5aec"]])

export default __exports__